<template>
  <div class="media-list">
    <subfield>
      <template slot="list">
        <trees type="GROUP" @getAssets="getAssets" :list="groupList"></trees>
        <trees type="CATALOG" @getAssets="getAssets" :list="configList"></trees>
      </template>
      <template slot="content">
        <enfold-ucd>
          <template slot="up">
            <div class="c-u-left">
              <img class="icon" src="@/assets/images/public/public_delete.png" @click="handleDel ()" alt />
            </div>
            <div class="c-u-right">
              <el-input v-model="keyword" :placeholder="$t('public.search')" @focus="keyword = undefined">
                <i slot="suffix" class="el-icon-search" @click="keyword && search(keyword)"></i>
              </el-input>
              <img src="@/assets/images/public/public_filter.png" @click="filter" class="icon" alt />
            </div>
          </template>
          <template slot="center">
            <el-table
              :data="mediaList"
              style="width: 100%"
              height="100%"
              row-key="id"
              @selection-change="handleSelectionChange"
              v-loading="loading"
            >
              <el-table-column type="selection" width="60" :reserve-selection="true"></el-table-column>
              <el-table-column prop="ref_name" label="名称"></el-table-column>
              <el-table-column prop="group_name" label="组织结构"></el-table-column>
              <el-table-column prop="dir_name" label="目录结构"></el-table-column>
              <el-table-column prop="type" label="类型" :formatter="formatType"></el-table-column>
              <el-table-column prop="ref_wh" label="文件尺寸"></el-table-column>
              <el-table-column prop="create_time" label="上传时间"></el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <div class="operation">
                    <img
                      class="icon"
                      src="@/assets/images/public/public_preview.png"
                      @click.stop="handlePreview (scope.$index, scope.row)"
                      alt
                    />
                    <img
                      class="icon"
                      src="@/assets/images/public/public_delete.png"
                      @click.stop="handleDel (scope.$index, scope.row)"
                      alt
                    />
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template slot="down">
            <pagination :current="current" :limit="limit" @currentChange="currentChange"></pagination>
          </template>
        </enfold-ucd>
      </template>
    </subfield>
    <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="DelCloseDialog" title="删除媒体">
      <div class="dd-dialog">请问是否要永久删除当前选中多媒体？</div>
    </del-dialog>
    <preview :previewData="previewData" @previewVisible="previewVisible"></preview>
    <msg-dialog :dialogVisible="msgDialogVisible" @closeDialog="closeDialog" top="20vh" title="文件筛选">
      <div v-for="(file,key) in fileType" :key="key" class="filter">
        <div class="title">{{file.typeName}}</div>
        <div class="check-all">
          <el-checkbox
            :indeterminate="file.isIndeterminate"
            v-model="file.checkAll"
            @change="handleCheckAllChange(file,file.checkAll)"
          >全选</el-checkbox>
        </div>
        <div class="check-item">
          <el-checkbox-group v-model="file.list" @change="handleCheckedChange(file,file.list)">
            <el-checkbox v-for="(item,index) in file.checkedList" :label="item" :key="index"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </msg-dialog>
  </div>
</template>

<script>
import subfield from '@/components/basics/Subfield'
import trees from '@/components/basics/Trees'
import EnfoldUcd from '@/components/basics/EnfoldUCD'
import pagination from '@/components/basics/Pagination'
import DelDialog from '@/components/basics/DelDialog'
import Preview from '@/components/basics/Preview'
import { mPreview, mPagination } from "@/components/basics/mixins"
import MsgDialog from '@/components/basics/MsgDialog'

export default {
  name: 'playlist',
  mixins: [mPreview, mPagination],
  data() {
    return {
      groupList: [],
      configList: [],
      mediaList: [],
      loading: false,
      DelDialogVisible: false,
      msgDialogVisible: false,
      multipleSelection: [],
      delId: "",
      delIds: "",
      fileType: null,
      type: undefined,
      refW: undefined,
      refSize: undefined,
      keyword: undefined
    }
  },
  created() {
    this.$http.post("/admin/access/groupList", {}, data => {
      this.groupList = data;
    });
    this.$http.post("/admin/material/configList", { flag: 1 }, data => {
      this.configList = data.dir;
    });
    this.fileType = this.fileTypeData();
    this.getMediaList();
  },
  activated() {
    this.getMediaList();
  },
  methods: {
    getMediaList(media = {
      limit: this.limit,
      group_ids: this.groupIds,
      dir_id: this.dirId,
      page: this.page,
      key_word: this.keyword,
      type: this.type,
      refW: this.refW,
      refSize: this.refSize
    }) {
      this.loading = true;
      this.$http.post("/admin/material/list", media, data => {
        this.mediaList = data.list ? data.list : [];
        this.current = parseInt(data.count);
        this.loading = false;
      });
      // this.mediaList && this.page > 1 ? this.page -= 1 : 0;
    },
    getAssets(ids) {
      if (ids.type === "GROUP") {
        this.groupIds = ids.ids
      }
      if (ids.type === "CATALOG") {
        this.dirId = ids.id
      }
      this.getMediaList();
    },
    currentChange(val) {
      this.page = val;
      this.getMediaList();
    },
    handleDel(index, row) {
      this.delId = "";
      this.delIds = "";
      if (index || row) {
        this.delId = row.id;
      } else {
        this.delIds = this.multipleSelection.map((ele) => ele.id).join(',');
      }
      this.DelDialogVisible = true;
    },
    formatType(row) {
      let refSize = (row.ref_size / 1024).toFixed(1);
      let refSizeMB = refSize / 1024;
      if (refSizeMB < 1) {
        refSize = (refSizeMB * 1024).toFixed(1) + "KB";
      } else if (refSizeMB >= 1 && refSizeMB < 1024) {
        refSize = refSizeMB.toFixed(1) + "MB";
      } else if (refSizeMB >= 1024) {
        refSize = (refSizeMB / 1024).toFixed(1) + "GB";
      }
      switch (row.type.toString()) {
        case "1": return `视频(${refSize})`;
        case "2": return `图片(${refSize})`;
        case "6": return `mp3(${refSize})`;
        case "10": return `文本(${refSize})`;
        default: return `未定义类型(${refSize})`;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    search(keyword) {
      this.keyword = keyword;
      this.getMediaList();
      // this.keyword = undefined;
    },
    closeDialog(isConfirm) {
      if (isConfirm) {
        // 数据处理函数
        let filter = (list, typeList, qr = true) => {
          let type = [];
          list.forEach((item) => {
            qr ? type = type.concat(typeList[item]) : type.push(typeList[item]);
          });
          return qr ? type.sort((a, b) => a - b) : type;
        }
        // 文件类型
        let type = [];
        let fileType = { '视频': [1], '图片': [2], '音乐': [6], '文本': [10] }
        // this.fileType.fileType.list.forEach((item) => {
        //   type.push(fileType[item]);
        // });
        type = filter(this.fileType.fileType.list, fileType);
        // 文件尺寸
        let ref_wh = [];
        let fileResolution = { '4K': [3264, 999999999], '2K': [2560, 3263], '1080P': [1920, 2559], '720P': [0, 1919] };
        // this.fileType.fileResolution.list.forEach((item) => {
        //   ref_wh = ref_wh.concat(fileResolution[item])
        // });
        // ref_wh = ref_wh.sort((a, b) => a - b);
        ref_wh = filter(this.fileType.fileResolution.list, fileResolution, false);
        //文件大小
        let ref_size = [];
        let fileSize = { '0M~10M': [0, 10485759], '10M~100M': [10485760, 104857599], '>100M': [104857600, 999999999] }
        // this.fileType.fileSize.list.forEach((item) => {
        //   ref_size = ref_size.concat(fileSize[item])
        // });
        // ref_size = ref_size.sort((a, b) => a - b);
        ref_size = filter(this.fileType.fileSize.list, fileSize, false);

        // 请求格式化
        this.type = type.length > 0 ? type.join(',') : undefined;
        this.refW = ref_wh.length > 0 ? encodeURIComponent(JSON.stringify(ref_wh)) : undefined;
        this.refSize = ref_size.length > 0 ? encodeURIComponent(JSON.stringify(ref_size)) : undefined;
        // this.refW = ref_wh.length > 0 ? JSON.stringify([(ref_wh[0]), (ref_wh[ref_wh.length - 1] === 999999999 ? null : ref_wh[ref_wh.length - 1])]) : undefined;
        // this.refSize = ref_size.length > 0 ? JSON.stringify([(ref_size[0]), (ref_size[ref_size.length - 1] === 999999999 ? null : ref_size[ref_size.length - 1])]) : undefined;
        this.page = 1;
        this.getMediaList();
      }
      this.msgDialogVisible = false;
    },
    filter() {
      this.msgDialogVisible = true;
    },
    fileTypeData() {
      return {
        fileType: {
          typeName: "文件类型",
          checkAll: false,
          checkedList: ['视频', '图片', '音乐', '文本'],
          list: [],
          isIndeterminate: false
        },
        fileResolution: {
          typeName: "文件尺寸",
          checkAll: false,
          checkedList: ['4K', '2K', '1080P', '720P'],
          list: [],
          isIndeterminate: false
        },
        fileSize: {
          typeName: "文件大小",
          checkAll: false,
          checkedList: ['0M~10M', '10M~100M', '>100M'],
          list: [],
          isIndeterminate: false
        }
      }
    },
    handleCheckAllChange(file, val) {
      file.list = val ? file.checkedList : [];
      file.isIndeterminate = false;
    },
    handleCheckedChange(file, list) {
      console.log(file, list);
      let checkedCount = list.length;
      file.checkAll = checkedCount === file.checkedList.length;
      file.isIndeterminate = checkedCount > 0 && checkedCount < file.checkedList.length;
    },
    DelCloseDialog(isConfirm) {
      if (isConfirm && this.delId) {
        this.$http.post("/admin/material/del", { id: this.delId }, data => {
          console.log(data);
          this.getMediaList();
        });
      }
      if (isConfirm && this.delIds) {
        this.$http.post("/admin/material/batchDel", { id: this.delIds }, data => {
          console.log(data);
          this.getMediaList();
        });
      }
      this.DelDialogVisible = false;
    }
  },
  components: {
    subfield,
    trees,
    EnfoldUcd,
    pagination,
    DelDialog,
    Preview,
    MsgDialog
  }
}
</script>

<style lang="scss" scoped>
.media-list {
  width: 100%;
  height: 100%;
  .c-u-left {
    height: 30px;
  }
  .c-u-right {
    display: flex;
    /deep/ .el-input__inner {
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
    }
    /deep/ .el-input__suffix {
      line-height: 30px;
      color: #2fb3ff;
      font-size: 16px;
      right: 10px;
    }
    .icon {
      margin-right: 0px;
      margin-left: 25px;
    }
  }
  /deep/ .cell {
    font-size: 16px;
  }
  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: #2fb3ff;
    }
    th:last-child > .cell {
      text-align: center;
    }
  }
  .operation {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .icon {
      margin: 0px;
    }
  }
  .icon {
    width: 30px;
    height: 30px;
    margin-right: 25px;
  }
  .dd-dialog {
    width: 100%;
    font-size: 16px;
    padding: 40px 0px;
    text-align: center;
  }
  .filter {
    padding-left: 18px;
    .title {
      text-align: center;
      font-size: 16px;
      color: #2fb3ff;
    }
    .check-all {
      padding-bottom: 6px;
    }
  }
  .filter + .filter {
    .title {
      padding-top: 10px;
    }
  }
}
</style>
